import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  input,
} from '@angular/core';

@Directive({
  selector: '[appFormNumericInput]',
  standalone: true,
})
export class NumericInputDirective {
  allowDecimalValue = input<boolean>(false);
  allowNegativeValue = input<boolean>(false);

  private numericRegExp = new RegExp(/^[0-9]{1,}$/);
  private readonly elementRef = inject(ElementRef);

  @HostListener('keypress', ['$event'])
  onKeypress(event: KeyboardEvent): boolean {
    const key: string = event.key;

    if (key === '.' && this.isValidDecimal) {
      return true;
    } else if (key === '-' && this.isValidNegativePrefix) {
      return true;
    } else if (!this.numericRegExp.test(key)) {
      return false;
    }
    return true;
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): boolean {
    const pasteData: string = event?.clipboardData?.getData('Text') ?? '';

    return this.numericRegExp.test(pasteData);
  }

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent): void {
    const currentValue: number = parseFloat(this.elementValue) || 0;
    if (!this.allowNegativeValue() && event.deltaY > 0 && currentValue <= 0) {
      event.preventDefault();
    }
  }

  private get isValidDecimal(): boolean {
    return !!this.allowDecimalValue() && !this.elementValue.includes('.');
  }

  private get isValidNegativePrefix(): boolean {
    return !!this.allowNegativeValue() && !this.elementValue.includes('-');
  }

  private get elementValue(): string {
    return this.elementRef.nativeElement.value;
  }
}
